import { im_proto } from '../../proto/index.js';
import { groupBy } from '../utils/tools.js';
import { PropertyStatus } from './Message.js';

class MessageProperty {
    // 其他字段...
    // 考虑软删除
    static fromOp(msg, op) {
        var _a;
        const p = new MessageProperty();
        p.conversationId = msg.conversationId;
        p.messageId = msg.clientId;
        p.key = op.key;
        p.userId = msg.ctx.option.userId;
        p.secUid = msg.ctx.option.secUid;
        p.createTime = new Date(Date.now());
        p.idempotentId = op.idempotentId;
        p.value = (_a = op.value) !== null && _a !== void 0 ? _a : ''; // 能进这个流程的必然是非remove/delete操作, 默认给个空值
        p.version = msg.version;
        p.status = PropertyStatus.Sending;
        return p;
    }
    static mergeOperationToCurrent(msg, ops) {
        var _a;
        // group by key
        const groupByKey = groupBy(ops, o => o.key);
        // 现在groupByKey里的就是本次要操作的, 先立即合并到本地
        // 后续push下来会重新刷新
        for (const key of Object.keys(groupByKey)) {
            for (const op of groupByKey[key]) {
                if (!msg.property[key]) {
                    msg.property[key] = [];
                }
                const existItem = (_a = msg.property[key]) === null || _a === void 0 ? void 0 : _a.findIndex(p => p.idempotentId === op.idempotentId);
                switch (op.operation) {
                    case im_proto.OPERATION_TYPE.ADD_PROPERTY_ITEM: // 追加item
                        if (existItem === -1) { // 不存在才能追加
                            msg.property[key].push(MessageProperty.fromOp(msg, op));
                        }
                        break;
                    case im_proto.OPERATION_TYPE.REMOVE_PROPERTY_ITEM: // 删除item
                        if (existItem !== -1) { // 存在才能删除
                            msg.property[key].splice(existItem, 1);
                        }
                        if (msg.property[key].length === 0) { // 所有的item都删掉了的话, 直接删掉整个key
                            delete msg.property[key];
                        }
                        break;
                    case im_proto.OPERATION_TYPE.SET_PROPERTY: // 直接把property设置成某个item
                        msg.property[key] = [MessageProperty.fromOp(msg, op)];
                        break;
                    case im_proto.OPERATION_TYPE.DEL_PROPERTY: // 清空property
                        delete msg.property[key];
                        break;
                }
            }
        }
    }
}

export { MessageProperty };
//# sourceMappingURL=MessageProperty.js.map
